module.exports = __webpack_public_path__ + "static/media/parking.a23c76d7.svg";